import React from "react"
import "@styles/components/slices/how-it-works-section.scss"
import { GatsbyImage } from "gatsby-plugin-image"

const HowItWorksSection = ({ slice }) => {
  return (
    <section className="how-it-works-section">
      <div className="how-it-works-section__wrapper">
        {slice.items.map(item => (
          <div
            key={`item-${item.title}`}
            className="how-it-works-section__item"
          >
            <div className="how-it-works-section__item__icon">
              <GatsbyImage
                image={item.icon.gatsbyImageData}
                alt={item.icon.alt}
              />
            </div>

            <div className="how-it-works-section__item__text-wrapper">
              <h3 className="how-it-works-section__item__title">
                {item.title}
              </h3>

              <p className="how-it-works-section__item__description">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default HowItWorksSection
